import adminpulse from '@/shared/utils/adminpulse';
import angular from 'angular';

angular
  .module('cxRegistrations')
  .controller('CreateRegistrationInvoiceDetailReportCtrl', [
    'close',
    'flySvc',
    '$element',
    '$http',
    'appUrls',
    'FileSaver',
    'relation',
    'filters',
    'batchParams',
    createRegistrationInvoiceDetailReportCtrl,
  ]);

function createRegistrationInvoiceDetailReportCtrl(
  close,
  flySvc,
  $element,
  $http,
  appUrls,
  FileSaver,
  relation,
  filters,
  batchParams,
) {
  const vm = this;
  vm.template = null;
  vm.templates = [];
  vm.showValidation = false;
  $http
    .get(`${appUrls.api}/api/DocumentTemplate/Templates`, {
      params: {
        templateType: 1,
        language: relation.langaugeCode,
        relationType: relation.type,
        companyId: relation.companyId,
      },
    })
    .then(({ data }) => {
      vm.templates = data;
    });

  vm.isValid = function() {
    if (!vm.template || !vm.template.id) return false;
    return true;
  };
  vm.showValidationErrors = function() {
    vm.showValidation = true;
  };
  vm.save = function(asPdf) {
    if (vm.saving || !vm.isValid()) return;
    vm.saving = true;

    $http
      .post(`${appUrls.api}/api/Registration/DetailReport`, batchParams, {
        params: {
          ...filters,
          templateId: vm.template.id,
          pdf: asPdf,
        },
        responseType: 'arraybuffer',
      })
      .then(
        result => {
          const contentDisposition = result.headers('Content-Disposition');
          const filename = adminpulse.getFileNameFromHeader(contentDisposition);

          const blob = new Blob([result.data], { type: result.headers('content-type') });
          if (blob) {
            FileSaver.saveAs(blob, filename);
          }
          $element.modal('hide');
          close(true, 500);
        },
        error => {
          if (!error) return;
          try {
            var buffer = error.data || error;
            const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
            flySvc.error(errorObject);
          } catch (ex) {
            console.error(ex);
            //Parsing error?
            flySvc.error();
          }
        },
      )
      .finally(() => {
        vm.saving = false;
      });
  };
  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
